import {useEffect, useState} from "react";
import {useRegisterSW} from "virtual:pwa-register/react";

const INITIAL_UPDATE_INTERVAL = 1000 * 60 * 10; // 1 minute

export const usePWAUpdate = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, registration) {
      console.info("Service worker has been registered at: ", swUrl);
    },
    onRegisterError(error) {
      console.error("SW registration error", error);
    },
  });

  return {needRefresh, setNeedRefresh, updateServiceWorker};
};
